import { defineMessages } from 'react-intl';

export default defineMessages({
  // Flags
  mfRecoveryCopiedTitle: {
    id: 'mf.recovery.copied',
    defaultMessage: 'Emergency recovery key is in your clipboard',
    description: '',
  },
  mfRecoveryCopiedDesc: {
    id: 'mf.recovery.copied.desc',
    defaultMessage: 'Paste it into a text file and save.',
    description: '',
  },
});
